import { gtag, install } from 'ga-gtag';

install('G-GJ8RF78V54');

gtag('js', new Date());
gtag('config', "G-GJ8RF78V54");